
























import {Component, Prop, Vue} from 'vue-property-decorator'
import {ServiceUpsertForm} from "@/form/TmodelForm";

import CudParamItems from "@/component/Thing/cud-param-items.vue";

@Component({
  components: {
    CudParamItems,
  },
})
export default class ServiceUpsertFormItems extends Vue {
  @Prop()
  private upsertForm!: ServiceUpsertForm
}
